
import './SeriesEpisodesPopup.scss';
import { EpisodePaneItem, EpisodePaneOpenItem } from './EpisodePaneItem'
import { useState } from 'react';
import EpisodePaneBack from './EpisodePaneBack';
import SeasonPane, { SeasonPaneItem } from './SeasonPane';
export interface SeriesSeason {
    id: string,
    name: string,
    episodes: string[]
}

export default function SeriesEpisodesPopup(props: {
    currentSeason: string,
    currentEpisode: string,
    seasons: SeriesSeason[],
    episodes: SeriesEpisode[],
    seriesTitle: string,
    onPlay: (episode: SeriesEpisode) => void,
    onChangeSeason: (seasonId: string) => void
}) {
    const [opened, setOpened] = useState(props.currentEpisode);
    const [showSeasons, setShowSeasons] = useState(false);
    let current = 'ltr-1k79dkt';
    let not_current = 'ltr-wpdr76';

    let season = props.seasons.find(v => v.id === props.currentSeason);
    return (
        <div className="ltr-8c73co show">
            <div className="ltr-m6m86k">
                <div className="watch-video--selector-episode-container medium">
                    <div className="ltr-1kbo5i1" data-uia="selector-episode">
                        <div data-show-focus="false" className="ltr-gtwgeq season-pane-component  episode-pane-control">
                            <SeasonPane active={showSeasons} seriesTitle={props.seriesTitle}>
                                {props.seasons.map((season: SeriesSeason) => {
                                    return <SeasonPaneItem
                                        active={props.currentSeason === season?.id}
                                        onClick={() => {
                                            setShowSeasons(false);
                                            if (props.currentSeason !== season?.id) {
                                                props.onChangeSeason(props.currentSeason);
                                            }
                                        }}
                                        title={season?.name}
                                        key={season?.id} />
                                })}
                            </SeasonPane>
                            <div data-uia="episode-pane" className={`${showSeasons ? 'ltr-1yqegg1' : 'ltr-1xeijo'}`}>
                                <EpisodePaneBack
                                    hasMultipleSeasons={props?.seasons?.length > 0}
                                    seasonTitle={season?.name}
                                    onClick={() => {
                                        setShowSeasons(true);
                                    }} />
                                <div tabIndex={-1} className="ltr-1d8v4z0  episode-pain episode-pain-open">
                                    {props.episodes.filter(x => {
                                        return season?.episodes?.find(v => v === x.id);
                                    }).map((episode, i: number) => {
                                        return <SeriesEpisodeComponent
                                            key={'episode' + episode.id + '-' + i}
                                            current={props.currentEpisode === episode.id}
                                            opened={opened === episode.id} data={{
                                                ...episode, episodeNumber: i + 1
                                            }} onOpen={() => {
                                                setOpened(episode.id);
                                            }} onPlay={() => {
                                                props.onPlay(episode)
                                            }} />
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export interface SeriesEpisode {
    id: string,
    episodeNumber: number,
    description: string,
    name: string,
    thumbnail: string
}
export function SeriesEpisodeComponent(props: {
    opened: boolean,
    current: boolean,
    data: SeriesEpisode,
    onOpen: () => void,
    onPlay: () => void
}) {
    // let not_current = 'ltr-wpdr76';
    // if (props.data && props.opened) {
    //     return <EpisodePaneOpenItem opened={props.opened} current={props.current} data={props.data} />
    // }
    return <EpisodePaneItem
        data={props.data}
        opened={props.opened}
        current={props.current}
        onOpen={props.onOpen}
        onPlay={props.onPlay} />
}

